angular.module('contabilidad.polizas')
  .service('facturacionService', ContabilidadPolizasIngresosProvisionService)

var padEnd = (string, length) => string.substring(0, length).padEnd(length)

function ContabilidadPolizasIngresosProvisionService ($http, $filter) {
  var schema = {
    poliza: {
      fecha: 'date',
      folio: 'number',
      total: 'number',
      moneda: {
        tipoCambio: 'number',
      },
      transacciones: {
        importe: 'number',
      },
    },
  }

  this.obtenerInformacionFacturacion = function (fecha_inicio, fecha_fin, ids_clientes) {
    return $http.get('/kendu/contabilidad/polizas/polizaFacturacion', {
      params: {
        fecha_inicio: fecha_inicio.toYMD(),
        fecha_fin: fecha_fin.toYMD(),
        ids_clientes: ids_clientes,
      },
      schema: schema,
    })
  }

  this.codificarFacturacion = function (data, inicio_poliza) {
    return data
      .reduce(function (registros, item, indice) {

        if (item.poliza.folio) {
          var fechaPoliza = padEnd($filter('date')(item.poliza.fecha, 'yyyyMMdd'), 12)
          var folio = padEnd('F-' + item.poliza.folio, 21)
          var tres = padEnd('3', 7)
          var inicioPoliza = inicio_poliza.toString().padStart(4, '0')
          var descripcion = (item.poliza.descripcion).padEnd(101)

          if (indice === 0) {
            registros.push('P  ' + fechaPoliza + tres + inicioPoliza + ' 1 0          ' + descripcion + '11 1 0')
          }

          item.poliza.transacciones.forEach(function (transaccion) {
            var cuentaContable = padEnd(transaccion.cuentaContable ? transaccion.cuentaContable.replace(/-/g, '') : '', 31)
            var importe = padEnd(transaccion.importe.toFixed(2), 21)
            var cero = padEnd('0', 11)
            var intereses = padEnd('0.0', 21)
            var concepto = (!transaccion.concepto ? '' : transaccion.concepto.substr(0, 44)).padEnd(44)
            var naturaleza = transaccion.naturaleza === 'C' ? '0' : '1'
            registros.push('M1 ' + cuentaContable + folio + naturaleza + ' ' + importe + cero + intereses + concepto)
          })
        }

        return registros
      }, [])
      .join('\\n')
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/facturacionService.js